<template>
  <b-card>
    <div class="d-flex justify-content-end mb-1">
      <b-button
        variant="success"
        @click="onAddClicked()"
        v-can="{ slug: $route.meta.slug, action: 'C' }"
      >
        <feather-icon icon="PlusIcon" />
        إضافة</b-button
      >
    </div>
    <hr />
    <data-table
      v-can="{ slug: $route.meta.slug, action: 'S' }"
      ref="usersTable"
      :fields="fields"
      ep="v2/users"
      :pagination="false"
    >
      <template #cell(is_blocked)="row">
        <span>{{ row.item.is_blocked ? "نعم" : "لا" }}</span>
      </template>
      <template #cell(is_locked)="row">
        <span>{{ row.item.is_locked ? "نعم" : "لا" }}</span>
      </template>
      <template #cell(actions)="row">
        <b-button
          variant="flat-info"
          title="عرض المزيد من المعلومات"
          size="sm"
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          class="btn-icon rounded-circle"
          v-b-tooltip.hover.v-info.top
          @click="row.toggleDetails"
        >
          <feather-icon icon="InfoIcon" size="1.8x" color="#82868b" />
        </b-button>
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>

          <b-dropdown-item @click="onUpdateClicked(row.item)">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">تعديل</span>
          </b-dropdown-item>

          <b-dropdown-item
            @click="onDelete(row.item)"
            v-can="{ slug: $route.meta.slug, action: 'D' }"
          >
            <feather-icon icon="Trash2Icon" />
            <span class="align-middle ml-50">حذف</span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="onPermissionsClicked(row.item)"
            v-can="{ slug: $route.meta.slug, action: 'O' }"
          >
            <feather-icon icon="UserCheckIcon" />
            <span class="align-middle ml-50">صلاحيات</span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="onAddClickedPassword(row.item)"
            v-can="{ slug: $route.meta.slug, action: 'O' }"
          >
            <feather-icon icon="KeyIcon" />
            <span class="align-middle ml-50">تغيير كلمة السر</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col md="4" class="mb-1 d-flex">
              <strong>حساب محظور:</strong>
              <div class="text-info mx-1">
                {{ row.item.is_blocked ? "نعم" : "لا" }}
              </div>
            </b-col>

            <b-col md="4" class="mb-1 d-flex">
              <strong>حساب مقفل : </strong>
              <div class="text-info mx-1">
                {{ row.item.is_locked ? "نعم" : "لا" }}
              </div>
            </b-col>
          </b-row>
        </b-card>
      </template>
    </data-table>

    <form-modal
      ref="userFormModal"
      :formSchema="userFormSchema"
      title="إضافة مستخدم"
      v-model="activModel"
      :loading="loading"
      @confirm="onModalConfirmed"
    >
      <template #password_must_change="{ form }">
        <b-form-checkbox class="my-1 mx-50" v-model="form.password_must_change">
          إجبار المستخدم على تغيير كلمة السر
        </b-form-checkbox>
      </template>
    </form-modal>
    <form-modal
      ref="userFormModal"
      :formSchema="updateFormSchema"
      title="تعديل المستخدم"
      v-model="updateModel"
      :loading="loading"
      @confirm="onModalConfirmed"
    >
      <template #password_must_change="{ form }">
        <b-form-checkbox class="my-1 mx-50" v-model="form.password_must_change">
          إجبار المستخدم على تغيير كلمة السر
        </b-form-checkbox>
      </template>
    </form-modal>

    <form-modal
      ref="passwordModalUser"
      :formSchema="passwordFormSchema"
      title="تغيير كلمة السر"
      :loading="loading"
      v-model="passwordactivModel"
      @confirm="onModalConfirmedPassword"
    >
    </form-modal>

    <form-modal
      ref="permissionsModalUser"
      :formSchema="permissionsFormSchema"
      title="تغيير الصلاحيات"
      :loading="loading"
      v-model="permissionsActivModel"
      @confirm="onModalConfirmedPermissions"
    ></form-modal>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BRow,
  BCol,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import DataTable from "@/components/data-table/index.vue";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { resolveUpdated } from "@/utils/utils";

export default {
  components: {
    BCard,
    BButton,
    DataTable,
    BDropdown,
    BDropdownItem,
    FormModal,
    BFormCheckbox,
    vSelect,
    BFormGroup,
    BRow,
    BCol,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      activModel: false,
      passwordactivModel: false,
      permissionsActivModel: false,
      updateModel: false,
      oldData: {},
      selected: [
        { title: "نعم", value: true },
        { title: "لا", value: false },
      ],
      fields: [
        {
          key: "full_name",
          label: "الاسم الكامل",
        },
        { key: "username", label: "اسم المستخدم", sortable: true },
        { key: "email", label: "البريد الإلكتروني", sortable: false },
        { key: "mobile", label: "رقم الموبايل" },
        { key: "phone", label: "رقم الهاتف" },
        { key: "actions", label: " " },
      ],
      userFormSchema: {
        full_name: {
          component: "FormInput",
          key: "full_name",
          attrs: {
            label: "الاسم الكامل*",
            rules: "required",
          },
        },
        username: {
          component: "UsernameInput",
          key: "username",
          attrs: {
            checkEp: "v2/check-unique",
            label: "اسم المستخدم",
            rules: "required",
          },
        },
        email: {
          component: "EmailInput",
          key: "email",
          attrs: {
            checkEp: "v2/check-unique",
            label: "البريد الإلكتروني*",
            rules: "required|email",
          },
        },
        mobile: {
          component: "MobileInput",
          key: "mobile",
          attrs: {
            id: "mobile-input",
            checkEp: "v2/check-unique",
            label: "رقم الموبايل*",
            rules: "required",
          },
        },
        phone: {
          component: "PhoneInput",
          key: "phone",
          attrs: {
            id: "phone-input",
            checkEp: "v2/check-unique",
            label: " رقم الهاتف",
          },
        },
        dob: {
          component: "FormMask",
          key: "dob",
          attrs: {
            label: "تاريخ الميلاد*",
            options: "date",
            rules: "required",
            placeholder: "YYYY-MM-DD",
          },
        },
        governorate_id: {
          component: "FormSelect",
          key: "governorate_id",
          attrs: {
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            id: "users_gov_manage_",
            label: "المحافظة*",
            ep: "v2/selects/governorates",
            rules: "required",
          },
        },
        is_blocked: {
          component: "FormSelect",
          key: "is_blocked",
          attrs: {
            id: "is_blocked",
            label: "حساب محظور*",
            rules: "required",
            reduce: (el) => el.value,
            options: [
              { label: "نعم", value: true },
              { label: "لا", value: false },
            ],
          },
        },
        is_locked: {
          component: "FormSelect",
          key: "is_locked",
          attrs: {
            id: "is_locked",
            label: "حساب مقفل*",
            rules: "required",
            reduce: (el) => el.value,
            options: [
              { label: "نعم", value: true },
              { label: "لا", value: false },
            ],
          },
        },
        password: {
          component: "GeneratePassword",
          key: "password",
          attrs: {
            id: "password",
            label: "كلمة السر *",
            rules: "required",
          },
        },
        password_must_change: { key: "password_must_change" },
      },
      updateFormSchema: {},
      passwordFormSchema: {
        old_password: {
          component: "FormPassword",
          key: "old_password",
          attrs: {
            id: "old_password",
            label: " كلمة السر الخاصة بك",
            rules: "required|min:8",
          },
        },
        new_password: {
          component: "FormPassword",
          key: "new_password",
          attrs: {
            id: "new_password",
            label: " كلمة السر الجديدة ",
            rules: "required|min:8",
          },
        },
        new_password_confirmation: {
          component: "FormPassword",
          key: "new_password_confirmation",
          attrs: {
            id: "new_password_confirmation",
            label: "تأكيد كلمة السر ",
            rules: "required|min:8",
          },
        },
      },

      permissionsFormSchema: {
        role_ids: {
          component: "FormSelect",
          key: "role_ids",
          attrs: {
            id: "role_ids",
            ep: "v2/selects/roles",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name,
            label: "الصلاحيات",
            rules: "required",
            multiple: true,
          },
        },
      },
      showDetails: false,
    };
  },
  computed: {
    ...mapGetters("tecSupport/Users", ["loading"]),
  },
  methods: {
    ...mapActions("tecSupport/Users", [
      "updateUser",
      "deleteUser",
      "addUser",
      "updateRouls",
      "changePassword",
    ]),
    onShowDetails(row) {
      row.toggleDetails();
      this.showDetails = !this.showDetails;
    },
    onDelete(item) {
      //
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المستخدم", {
          title: "تأكيد حذف المستخدم",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "جاري الحذف ...",
              icon: "Trash2Icon",
              variant: "info",
            },
          });
          if (value)
            this.deleteUser({ id: item.id }).then(() => {
              this.$refs.usersTable.refreshTable();
            });
        });
    },

    onUpdateClicked(form) {
      this.oldData = { ...form };
      delete this.oldData.governorate;
      delete this.oldData.ngoRoles;

      var toUpdate = {
        id: form.id,
        full_name: form.full_name,
        username: form.username,
        password: form.password,
        governorate_id: form.governorate.id,
        dob: form.dob,
        mobile: form.mobile,
        phone: form.phone,
        email: form.email,
        is_blocked: form.is_blocked,
        is_locked: form.is_locked,
        password_must_change: form.password_must_change ? true : false,
      };
      const selectedPassword = ["password"];
      const filteredUsers = Object.keys(this.userFormSchema)
        .filter((key) => !selectedPassword.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.userFormSchema[key];
          return obj;
        }, {});

      this.updateFormSchema = filteredUsers;
      this.$refs.userFormModal.init(toUpdate);
      this.updateModel = true;
    },
    onPermissionsClicked(form) {
      var toUpdate = {
        id: form.id,
        role_ids: form.ngoRoles,
      };
      this.$refs.permissionsModalUser.init(toUpdate);
      this.permissionsActivModel = true;
    },
    onAddClicked() {
      this.$refs.userFormModal.init({});
      this.passwordactivModel = false;
      this.activModel = true;
    },
    onAddClickedPassword(form) {
      var toUpdate = {
        id: form.id,
      };
      this.$refs.passwordModalUser.init(toUpdate);
      this.activModel = false;
      this.passwordactivModel = true;
    },

    onModalConfirmed(form) {
      if (form.id) {
        var toSend = resolveUpdated(form, this.oldData);
        this.updateUser({ id: form.id, fd: toSend }).then(() => {
          this.$refs.usersTable.refreshTable();
          this.updateModel = false;
        });
      } else
        this.addUser({ fd: form }).then(() => {
          this.$refs.usersTable.refreshTable();
          this.activModel = false;
        });
    },

    onModalConfirmedPassword(form) {
      const toUpdate = {
        new_password: form.new_password,
        new_password_confirmation: form.new_password_confirmation,
        old_password: form.old_password,
      };
      this.changePassword({ id: form.id, fd: toUpdate }).then(() => {
        this.$refs.usersTable.refreshTable();
        this.passwordactivModel = false;
      });
    },

    onModalConfirmedPermissions(form) {
      this.updateRouls({ id: form.id, fd: { role_ids: form.role_ids } }).then(
        () => {
          this.$refs.usersTable.refreshTable();
          this.permissionsActivModel = false;
        }
      );
    },
  },
};
</script>
